import { put, call, take, fork } from 'redux-saga/effects'
import { courseFilterService } from '../../api/course'
import { courseFilterSuccess } from '../../reducers/course/action'
import { COURSE_FILTER } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseFilterFlow(payload) {
  try {
    const { data, callback } = payload
    const response = yield call(courseFilterService, data)
    yield put(courseFilterSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data.results)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseFilterWatcher() {
  while (true) {
    const action = yield take(COURSE_FILTER)
    const { payload } = action

    yield fork(generalSaga, courseFilterFlow, payload, false)
  }
}
